<template>
  <CRow>
    <CCol sm="12" lg="12" md="12" xl="4">
    <CCard>
    <CCardHeader><b>Personal Info</b><CButton variant="outline" class="ml-3" size="sm" @click="openModalEdit(datas.data.uuid)" color="primary"><b-icon icon="pencil" font-scale="1" scale="1" ></b-icon></CButton></CCardHeader>
      <CListGroup >
        <CListGroupItem href="#"> <img class=" c-avatar-img-detail mt-3" v-bind:src="getPhoto(datas.data.get_photo)" width="100" height="110"> <div class="d-flex justify-content-center mt-2"><b> {{ datas.data.firstname }} {{ datas.data.lastname }} </b> </div>  </CListGroupItem>
        <CButton  @click="openModalEditPhoto(datas.data.uuid)" color="dark"><b-icon class="mr-2" icon="images" font-scale="1.3" scale="1" ></b-icon><b style="color:white">Update Profile Picture</b></CButton>
        <CListGroupItem href="#"> Name :  {{ datas.data.firstname }} {{ datas.data.lastname }}  </CListGroupItem>
        <CListGroupItem href="#"> Gender : {{ datas.data.sex }} </CListGroupItem>
        <CListGroupItem href="#"> DOB : {{ dob }} </CListGroupItem>
        <CListGroupItem class="d-flex justify-content-between" href="#"> Class : {{ datas.data.ikid_class.name }}
            <CBadge v-if="datas.data.checkin_status !== null && datas.data.checkin_status.action == 'in class'" color="success"> In Class </CBadge>
            <CBadge v-if="datas.data.checkin_status !== null && datas.data.checkin_status.action == 'queued'" color="success">In Queued </CBadge>
            <CBadge v-if="datas.data.checkin_status !== null && datas.data.checkin_status.action == 'check out'" color="danger">Check Out</CBadge> </CListGroupItem>
        <CListGroupItem href="#"> Grade : {{ datas.data.ikid_grade ? datas.data.ikid_grade.name : '' }} </CListGroupItem>
        <CListGroupItem class="d-flex justify-content-between" href="#"> Dad : {{ dad }} <CButton  v-if="dad_id" size="sm" @click="show_parent(dad_id)"  variant="outline" color="info">Show </CButton> </CListGroupItem>
        <CListGroupItem class="d-flex justify-content-between" href="#"> Mom : {{ mom }} <CButton v-if="mom_id" size="sm" @click="show_parent(mom_id)"  variant="outline" color="info">Show </CButton> </CListGroupItem>
        <CListGroupItem class="d-flex justify-content-between" href="#"> Guardian : {{ guardian }} <CButton v-if="guardian_id" size="sm" @click="show_parent(guardian_id)"  variant="outline" color="info">Show </CButton> </CListGroupItem>
        <CButton v-if="datas.data.ikid_class.name == 'Incredible'  && datas.data.is_active == '1'" @click="openModalGraduate(datas.data.uuid)" variant="outline" color="info"><b>GRADUATE</b></CButton>
      </CListGroup>
    </CCard>
</CCoL>
<CCol sm="12" lg="12" md="12" xl="8" >
      <CCard>
          <CCardBody>
            <CTabs variant="pills">
              <CTab  title="Note" active>
                <hr>
                <CCol xl="12">
                    <CButton @click="openModalNewNote()" variant="outline" color="info"><b>New Note</b></CButton>
                    <div>
                      <CCard class="mt-3" v-for="item in datas.data.ikid_note" :key="item.id">
                        <CButton
                          block
                          color="link"
                          class="text-left shadow-none card-header"
                          @click="accordion = accordion === `${item.id}` ? false : `${item.id}`"
                        >
                          <h6>{{ item.subject}}</h6>
                        </CButton>
                        <CCollapse :show="accordion === `${item.id}`">
                          <CCardBody>
                            {{ item.content }}
                            <br><br><CButton @click="openModalEditNote(item.id)" color="primary" size="sm"><b-icon icon="pencil"></b-icon></CButton>
                            <CButton class="ml-2" @click="destroyNote(item.id)" color="danger" size="sm"><b-icon icon="trash"></b-icon></CButton>
                          </CCardBody>
                        </CCollapse>
                      </CCard>
                    </div>
                </CCol>
              </CTab>


              <CTab title="Activity Log" >
                <CCol xl="12">
                  <hr>
                  <div class="table-container">
                    <table class="table">
                    <thead>
                        <tr>
                          <th v-for="item in fieldsLog" :key="item.title">
                              {{ item.title }}
                          </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="i in itemsLog" :key="i.id">
                          <td>
                              {{ (i.name) }}
                          </td>
                          <td>
                              {{ (i.action) }}
                          </td>
                          <td>
                              {{ (i.log_time) }}
                          </td>
                        </tr>
                    </tbody>
                    </table>
                  </div>
                </CCol>
              </CTab>
            </CTabs>
          </CCardBody>
        </CCard>
</CCoL>

    <ikidmodal></ikidmodal>
    <ikidmodalphoto></ikidmodalphoto>
    <ikidmodalnote></ikidmodalnote>
    <ikidmodalgraduate></ikidmodalgraduate>
    <alertmodal></alertmodal>
  </CRow>

</template>

<script>
import moment from 'moment';
import EventBus from '@/eventBus';
import alertmodal from '@/views/alert/modal.vue';

import ikid from '@/services/ikid'
import axios from 'axios'
import ikidmodal from './ikidsmodal.vue';
import ikidmodalphoto from './ikidsmodalphoto.vue';
import ikidmodalnote from './ikidsmodalnote.vue';
import ikidmodalgraduate from './ikidsmodalgraduate.vue';
import DatatableLog from '@/components/datatables_ikid_check_log.vue'

import store from '@/store.js'

export default {
name: 'detailmodal',
components: { ikidmodal, alertmodal, ikidmodalphoto, ikidmodalnote, ikidmodalgraduate },
  data () {
    return {
      accordion: '',
      mode: '',
      datas:[],
      dob:'',
      dad:'',
      dad_id:'',
      mom:'',
      idKids: this.$route.query.id,
      mom_id:'',
      guardian:'',
      guardian_id:'',
      form:{
        uuid:''
      },
      fieldsLog: [
          {title: 'name', sortable: false, },
          {title: 'action', sortable: false},
          {title: 'log_time', sortable: false},
      ],
      itemsLog: [],
      metaLog: [],
      current_page: 1,
      per_page: 10,
      current_pageLog: 1,
      per_pageLog: 10,
      search: '',
      sortBy: 'name',
      sortByDesc: false,
      sortByLog: 'log_time',
      sortByDescLog: true,
      is_active: 1,
      permission: true,
      //end
      }
  },
  mounted(){
    this.load()
    EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.load();
      }
    });
  },

  beforeDestroy(){
    EventBus.$off('TABLE_UPDATE', this.listener)
   },
 methods:{
   getPhoto(data){
        if (data){
            return axios.defaults.baseURL + '/getfile/' + data.path + '/' + data.filename
        }else{
            return axios.defaults.baseURL + '/getfile/memberphoto/no_photo.jpg'
        }

    },
    openModalEdit(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit kid (including edit class/parents/etc)') !== -1){
          //IF ALLOW
        var params = {title: 'Edit Kid', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_IKID', params)
        //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }
      }
      //SET END
    },
    openModalEditPhoto(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit kid (including edit class/parents/etc)') !== -1){
          //IF ALLOW
        var params = {title: 'Edit Kid Photo', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_IKID_PHOTO', params)
        //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }
      }
      //SET END
    },
    openModalEditNote(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Add/edit kid note') !== -1){
          //IF ALLOW
        var params = {title: 'Edit Kid Note', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_IKID_NOTE', params)
        //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }
      }
      //SET END
    },
    openModalNewNote(){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Add/edit kid note') !== -1){
          //IF ALLOW
        var params = {title: 'New Kid Note', mode:'create'}
        EventBus.$emit('OPEN_MODAL_IKID_NOTE', params)
        //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }
      }
      //SET END
    },
    destroyNote(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Delete kid note') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to delete this note?")){
        ikid.deleteIkidNote(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
        //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }
      }
      //SET END
      }
    },


    load(){

      this.dad = null
      this.dad_id = null
      this.mom = null
      this.mom_id = null
      this.guardian = null
      this.guardian_id = null

      let current_page = this.search == '' ? this.current_page:1
      var paramsLog = {
        //headers: { "Authorization" : `Bearer ${token}` },
        page: this.current_pageLog,
        per_page: this.per_pageLog,
        sortby: this.sortByLog,
        sortbydesc: this.sortByDescLog ? 'DESC':'ASC',
        is_active: this.is_active,

      }
        ikid.getIkidbyID(this.$route.query.id)
        .then(res => {
            this.datas = res;
            this.dob = moment(res.data.dob).format ('DD MMMM YYYY')
            if(res.data.dad !== null){
                this.dad = res.data.dad.firstname + " " + res.data.dad.lastname
                this.dad_id = res.data.dad.uuid
            }
            if(res.data.mom !== null){
                this.mom = res.data.mom.firstname + " " + res.data.mom.lastname
                this.mom_id = res.data.mom.uuid
            }
            if(res.data.guardian !== null){
                this.guardian = res.data.guardian.firstname + " " + res.data.guardian.lastname
                this.guardian_id = res.data.guardian.uuid
            }
        }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
        })


        ikid.getIkidActivity(paramsLog)
        .then(res => {
          let getData = res.data
          this.itemsLog = getData.data.filter(item => item.uuid === this.idKids )
          //this.is_active = res.is_active
          this.metaLog = {
              total: getData.total,
              current_page: getData.current_page,
              per_page: getData.per_page,
              from: getData.from,
              to: getData.to,
              is_active: res.is_active,
          }
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })

    },

    show_parent: function(uuid){
      this.$router.push({name:'Member Detail',query: {Pud:uuid} })
    },

    handlePerPageLog(val) {
        this.per_pageLog = val
        this.load()
    },

    handlePaginationLog(val) {
        this.current_pageLog = val
        this.load()
    },

    handleSearch(val) {
        this.search = val
        this.current_page = 1
        this.load()
    },

    handleSort(val) {
        this.sortBy = val.sortBy
        this.sortByLog = val.sortBy
        this.sortByDesc = val.sortDesc
        this.sortByDescLog = val.sortDesc
        this.load()
    },

    // graduate(id){
    //     ikid.graduate(id)
    //     .then(res => {
    //       EventBus.$emit('PAGE_UPDATE', true)
    //       var params = {title: 'Success', mode:'success', data:res.message}
    //       EventBus.$emit('OPEN_MODAL_ALERT', params)
    //     }).catch ((err) => {
    //         var params = {title: 'Error', mode:'danger', data:err.response.data.message}
    //         EventBus.$emit('OPEN_MODAL_ALERT', params)
    //     })
    // },
    openModalGraduate(id){
      //SET PERMISSION EACH FEATURE
      // let Permission = store.state.user.authenticated.permission
      // if (typeof Permission != 'undefined') {
      //   if(Permission.indexOf('Add/edit kid note') !== -1){
          //IF ALLOW
        var params = {title: 'Need Additional Information?', mode:'create', data:id}
        EventBus.$emit('OPEN_MODAL_IKID_GRADUATE', params)
        //END ALLOW
      //   }else{
      //     //IF NOT
      //     var params = {title: 'Error', mode:'danger', data:'unautenticated'}
      //     EventBus.$emit('OPEN_MODAL_ALERT', params)
      //     console.log(' open modal edit')
      //   }
      // }
      //SET END
    },
  }
}

</script>

<style>
  .c-avatar-img-detail {
width: 100px !important;
height: 100px !important;
border-radius: 10em !important;
display: block !important;
margin-left: auto !important;
margin-right: auto !important;
}

@media screen and (min-width: 500px) {
  .c-avatar-img-detail {
width: 200px !important;
height: 200px !important;
border-radius: 10em !important;
display: block !important;
margin-left: auto !important;
margin-right: auto !important;
}
}

@media screen and (min-width: 720px) {
  .c-avatar-img-detail {
width: 200px !important;
height: 200px !important;
border-radius: 9em !important;
display: block !important;
margin-left: auto !important;
margin-right: auto !important;
}
}

@media screen and (min-width: 1024px) {
  .c-avatar-img-detail {
  width: 200px !important;
  height: 200px !important;
  border-radius: 10em !important;
  display: block !important;
  margin-left: auto !important;
  margin-right: auto !important;

}
}

</style>
